// extracted by mini-css-extract-plugin
module.exports = {"h5-main-stream":"h5-main-stream___3xTVy","no-border":"no-border___2EFiN","view":"view___3T4mA"};